import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ICivilStatusCommonDomain } from '../interface/ICivilStatusCommonDomain';
import { IFeatureToggleConfig } from '../interface/IFeatureToggleConfig';

enum CommonDomainServiceEnum {
	getAll = '/getAll',
	edit = '/edit',
	save = '/save',
	delete = '/delete',
	diligenceQuestionsJson = '/diligence-questions-json/',
	attorneyJson = '/attorney-json',
	getCourt = '/get-court',
	getBankList = '/get-bank/',
	getDomainByCode = '/get-domain-by-code/',
	getCivilStatus = '/get-civil-status',
	appVersion = '/app-version',
	PercentageP1 = '/value-percentage'
}

export default class CommonDomainService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/common-domain');
	}

	public getAll = async () => await this.GET(CommonDomainServiceEnum.getAll);
	public edit = async data => await this.PUT(CommonDomainServiceEnum.edit, data);
	public save = async data => await this.POST(CommonDomainServiceEnum.save, data);
	public delete = async data => await this.DELETE(CommonDomainServiceEnum.delete, data);
	public getDiligenceQuestionJson = async domain => await this.GET(CommonDomainServiceEnum.diligenceQuestionsJson + domain);
	public getAttorneyJson = async () => await this.GET(CommonDomainServiceEnum.attorneyJson);
	public getBankList = async (): Promise<any> => await this.GET(CommonDomainServiceEnum.getBankList);
	public getCivilStatus = async (): Promise<ICivilStatusCommonDomain> => await this.GET(CommonDomainServiceEnum.getCivilStatus);
	public getDomainByCode = async (code: string): Promise<any> => await this.GET(CommonDomainServiceEnum.getDomainByCode + code);
	public getFeatureToggleConfig = async (): Promise<IFeatureToggleConfig> => this.getDomainByCode("feature_management")
	public getPercentageP1 = async (): Promise<number> => await this.GET(CommonDomainServiceEnum.PercentageP1);
}
